module.exports = __webpack_public_path__ + "static/media/Omri Aharon.692eb084.png";